import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { useDispatch } from "react-redux"
import { Flex, Tabs, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { fetchBookingSummary } from "store/bookings"

const { Text } = Typography

// A tab per booking of a cart order on the booking confirmation page (QA Ticketing #27). The link
// lists the order's bookings, each read like the page reads its own (no token), so it opens in any
// browser later; picking a tab opens that booking.
const OrderBookingTabs = ({ bookingUuids, bookingUuid, onSelect }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [summaries, setSummaries] = useState({})

  useEffect(() => {
    bookingUuids.forEach((uuid) =>
      dispatch(fetchBookingSummary(uuid))
        .then((booking) => setSummaries((current) => ({ ...current, [uuid]: booking })))
        .catch(() => {})
    )
  }, [bookingUuids, dispatch])

  if (bookingUuids.length < 2) return null

  const orderNumber = Object.values(summaries).find((booking) => booking?.order_number)?.order_number
  const items = bookingUuids.map((uuid) => {
    const booking = summaries[uuid]
    return {
      key: uuid,
      label: (
        <Flex vertical align="flex-start">
          <Text strong>{booking?.trip?.title || (booking?.booking_number ? t("booking_widget.success.booking_id", { id: booking.booking_number }) : "…")}</Text>
          {booking?.booked_datetime && <Text type="secondary">{booking.booked_datetime}</Text>}
        </Flex>
      )
    }
  })

  return (
    <Flex vertical gap={8}>
      {orderNumber && <Text strong>{t("booking_widget.success.order_id", { id: orderNumber })}</Text>}
      <Tabs activeKey={bookingUuid} items={items} onChange={onSelect} />
    </Flex>
  )
}

OrderBookingTabs.propTypes = {
  bookingUuids: PropTypes.arrayOf(PropTypes.string).isRequired,
  bookingUuid: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired
}

export default OrderBookingTabs
